import { createPrefetchableAsyncDataContext, pageDataErrorHandler } from '#src/app/shared/contexts/asyncData';

import { getSearchPageData } from './api';
import type { SearchPageDataErrorCode } from './types';

export const {
	Context: SearchPageDataContext,
	Provider: SearchPageDataContextProvider,
	useContext: useSearchPageData,
	useAsyncData: useSearchPageDataFromApi,
	prefetchAsyncData: prefetchSearchPageDataFromApi,
} = createPrefetchableAsyncDataContext({
	name: 'SearchPageDataContext',
	dataProperty: 'pageData',
	getData: getSearchPageData,
	errorHandler: pageDataErrorHandler<SearchPageDataErrorCode>(),
});
